import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card, Table, Row, Col, Nav, Dropdown } from "react-bootstrap";
import API from "api.js";
import { NavLink, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { store } from "store/index";
import ct, { getAllCountries, getTimezonesForCountry } from "countries-and-timezones";
import cityTimeZones from "city-timezones";
import moment from "moment-timezone";
import { getTimeZones } from "@vvo/tzdb";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

// import { thead, tbody } from "variables/general";
import TopNavPills from "components/SectionalTest/TopNavPills";
import SidebarClose from "components/Sidebar/SidebarClose";
import convertTo12Hrs from "util/convertTo12Hrs";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";
import MockPagination from "components/Question/Mocks/Pagination";

const MockResult = () => {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [currentSection, setCurrentSection] = useState("Speaking Section");
  const [timezone, setTimezone] = useState("");
  const [abbrev, setAbbrev] = useState("UTC");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [displaying_items, setDisplaying_items] = useState(10);

  const getMocks = (new_format) => {
    setIsLoading(true)
    API({
      method: "GET",
      url: "mock/result?new_format=" + new_format,
    })
      .then((response) => {
        if (location.pathname === "/admin/results") {
          toggle(1);
        }
        console.log("response.data.result---", response.data.result);

        const allData = response.data.result;
        setData(allData);
        setTotal(allData.filter((item) => item.mock && item.mock.category === activeTab).length);
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      });
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      let newSection = "";
      switch (tab) {
        case 1:
          newSection = "Speaking Section";
          break;
        case 2:
          newSection = "Writing Section";
          break;
        case 3:
          newSection = "Reading Section";
          break;
        case 4:
          newSection = "Listening Section";
          break;
        case 5:
          // code block
          break;
        default:
        // code block
      }
      setActiveTab(tab);
      setCurrentSection(newSection);
      setPage(1); // Reset to page 1 when tab changes
    }
  };

  useEffect(() => {
    let new_format = 0;
    if (location.pathname === "/admin/results") {
      new_format = 1;
    }

    getMocks(new_format);

    const timeZones = getTimeZones();

    const { country_residence, country_state } = store.getState().user;
    if (country_residence) {
      const country = Object.values(getAllCountries()).find(
        (obj) => obj.name === country_residence
      );
      if (country) {
        if (country.timezones.length === 1) {
          const timezone = country.timezones[0];
          const abbrev = timeZones.find(
            (obj) => obj.name === timezone
          ).abbreviation;
          // console.log(moment.tz(timezone).format('z'))
          setTimezone(timezone);
          setAbbrev(abbrev);
        }
      }
    }
  }, []);

  // useEffect(() => {
  //   if (location.pathname.includes("results")) {
  //     // document.body.classList.add("leftSidebarClosed");
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/admin/results") {
      getMocks(1);
    } else if (location.pathname === "/admin/mock-result") {
      getMocks(0);
    }
  }, [location.pathname]);

  // Update total when activeTab changes
  useEffect(() => {
    setTotal(data.filter((item) => item.mock && item.mock.category === activeTab).length);
    setPage(1); // Reset to page 1 when tab changes
  }, [activeTab, data]);

  // Update display items per page
  const updateListingItems = (items, page) => {
    setDisplaying_items(items);
    setPage(page);
  };

  // Change Pagination
  const paginationChange = (page) => {
    setPage(page);
  };

  // Filter data for the current page
  const getPaginatedData = () => {
    const filteredData = data.filter((item) => item.mock && item.mock.category === activeTab);
    const startIndex = (page - 1) * displaying_items;
    const endIndex = startIndex + displaying_items;
    return filteredData.slice(startIndex, endIndex);
  };

  // console.log("data==", data);


  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>
      <div className="content mockResult tabs-content p-0 mock-test">
        <DashboardHeader title={location.pathname === "/admin/results" ? "Extensive Mock Result Analysis":"Mock Result Analysis"} />
        <Row className="outer-wrapper">
        <Col xs={12} className="sp-0">
            <Card className="border-0 card-wrapper m-0 m-md-4 w-auto ">
              <div className="dailytask-header mt-2">
                <div className="dailytask-title px-3">{location.pathname === "/admin/results" ? "Extensive":""} Mock Result Analysis</div>
                <div className="d-flex align-items-center">
                  {activeTab !== 5 && (
                    <Link
                      className="text-decoration-none"
                      to={"/admin/progress/" + activeTab + "?mock=" + (location.pathname === "/admin/results" ? "2" : "1")}
                    >
                      <div className="score-analysis-btn">
                        Score Analysis of {currentSection}
                      </div>
                    </Link>
                  )}
                  <div className="w-100 px-3">
                    <div className="d-md-none mb-3">
                      <Dropdown className="w-100 mobile-category-dropdown">
                        <Dropdown.Toggle variant="none" id="dropdown-basic" className="w-100 text-start d-flex justify-content-between align-items-center">
                          <span>
                            {[
                              "Speaking",
                              "Writing",
                              "Reading",
                              "Listening",
                              "Full Mock Test",
                            ][activeTab - 1]}
                          </span>
                          <i className="fa fa-chevron-down small opacity-50"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {(location.pathname === "/admin/results"
                            ? ["Speaking", "Writing", "Reading", "Listening"]
                            : ["Speaking", "Writing", "Reading", "Listening", "Full Mock Test"]
                          ).map((label, idx) => (
                            <Dropdown.Item
                              key={idx}
                              active={activeTab === idx + 1}
                              onClick={() => toggle(idx + 1)}
                            >
                              {label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>

                    <div className="d-none d-md-block">
                      {location.pathname !== "/admin/results" && (
                        <Nav
                          className="nav-pills-primary nav-pills-icons justify-content-center"
                          pills
                          role="tablist"
                          variant="tabs"
                        >
                          <Nav.Item>
                            <Nav.Link
                              className={activeTab === 1 ? "active" : ""}
                              onClick={() => {
                                toggle(1);
                              }}
                            >
                              Speaking
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className={activeTab === 2 ? "active" : ""}
                              onClick={() => {
                                toggle(2);
                              }}
                            >
                              Writing
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className={activeTab === 3 ? "active" : ""}
                              onClick={() => {
                                toggle(3);
                              }}
                            >
                              Reading
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className={activeTab === 4 ? "active" : ""}
                              onClick={() => {
                                toggle(4);
                              }}
                            >
                              Listening
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className={activeTab === 5 ? "active" : ""}
                              onClick={() => {
                                toggle(5);
                              }}
                            >
                              Full Mock Test
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>
                      )}
                      {location.pathname === "/admin/results" && (
                        <TopNavPills activeTab={activeTab} toggle={toggle} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {activeTab === 2 && <div className="score-analysis-btn text-black" style={{width : "fit-content" , border: "1px solid #0286ff" , backgroundColor:"#e1f0ff", borderRadius:"4px"}} >
                      Writing Mock results may take slightly longer to generate. <span style={{ fontWeight: "bold" }}>*</span>
                      </div>}
               
              <Card.Body className={`p-0 ${getPaginatedData()?.length > 0 ? "listing_height listing_height_test" : ""}`}>
                <div className="mockResultOuter table-wrapper">
                  {isLoading ? (
                    <div className="text-center p-5">
                      <Spinner />
                    </div>
                  ) : getPaginatedData()?.length === 0 ? (
                    <div className="p-3 text-center">
                      <EmptyData text={"No Tests Result Found"} />
                    </div>
                  ) : (
                    <>
                      <div className="d-none d-md-block">
                        <Table>
                          <thead className="text-primary">
                            <tr>
                              <th className="table-counting">#</th>
                              <th className="">Title</th>
                              <th className="">Started at</th>
                              <th className="">Action</th>
                              <th className="">Scorecard</th>
                              <th className="">Analysis</th>
                              <th className="">Tutor Feedback</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getPaginatedData().map((val, key) => {
                              var score = val.total;
                              var now = new Date();
                              var today = new Date(now.toUTCString().slice(0, -4));
                              var diffMs = today - up;
                              var up = new Date(val.updated_at);
                              let formattedUp = up
                                .toISOString()
                                .replace("T", " ")
                                .slice(0, 16);
                              if (abbrev !== "UTC") {
                                const formattedDate = new Date(
                                  val.updated_at
                                ).toLocaleString("en-US", {
                                  timeZone: timezone,
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                  hour12: true,
                                  hour: "numeric",
                                  minute: "2-digit",
                                });

                                // Split the date and time parts
                                const [datePart, timePart] = formattedDate.split(",");

                                // Split the date into month, day, and year
                                const [month, day, year] = datePart.split("/");

                                // Combine the formatted date parts
                                const formattedDateResult = `${year}-${parseInt(
                                  month
                                )}-${parseInt(day)}`;

                                // Combine the formatted date and time
                                formattedUp = `${formattedDateResult}, ${timePart}`;

                                // console.log(formattedUp); // Output the final formatted date and time
                              }
                              var minutes = Math.floor(diffMs / 1000 / 60);
                              return (
                                <tr key={key}>
                                  <td>{(page - 1) * displaying_items + key + 1}</td>
                                    <td className="">
                                      {val.mock.title ? val.mock.title : ""}
                                    </td>
                                    <td className="">
                                      {val.local_date
                                        ? convertTo12Hrs(val.local_date)
                                        : (formattedUp ? formattedUp : "") + abbrev}
                                        {/* {score
                                          ? (val.local_date
                                              ? convertTo12Hrs(val.local_date)
                                              : `${formattedUp ? formattedUp : ""} ${abbrev}`)
                                          : "--:--"} */}
                                    </td>
                                    <td className="">
                                      {score ? (
                                        <NavLink
                                          to={"/admin/result/" + val.id}
                                          className="nav-link"
                                          activeClassName="active"
                                        >
                                          <i className="" />
                                          <div className="view-btn">
                                            View Feedback
                                          </div>
                                        </NavLink>
                                      ) : (
                                        "Please Wait..."
                                      )}
                                    </td>
                                    <td>
                                      {score ? (
                                        <NavLink
                                          to={"/admin/scorecard/" + `${location.pathname !== "/admin/results" ? 'Mock' : 'Extensive'}/` + val.id}
                                          className="nav-link"
                                          activeClassName="active"
                                        >
                                          <i className="" />
                                          
                                             <div className="view-btn view-small-btn">
                                            View Score
                                          </div>                                          
                                        </NavLink>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    <td>
                                      {score ? (
                                        <NavLink
                                          to={"/admin/analysis/"+ `${location.pathname !== "/admin/results" ? 'Mock' : 'Extensive'}/` + val.id}
                                          className="nav-link"
                                          activeClassName="active"
                                        >
                                          <i className="" />{" "}
                                          <div className="view-btn view-small-btn">
                                            View Analysis
                                          </div>
                                        </NavLink>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    <td>
                                      {score ? (
                                        <NavLink
                                          to={"/mock-feedback/" + val.id}
                                          className="nav-link"
                                          activeClassName="active"
                                        >
                                          <i className="" />
                                          <div className="view-btn view-small-btn">
                                            View
                                          </div>{" "}
                                        </NavLink>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                  </tr>
                                );
                            })}
                          </tbody>
                        </Table>
                      </div>

                      <div className="mobile-table d-md-none mt-3">
                        {getPaginatedData().map((val, key) => {
                          var score = val.total;
                          var up = new Date(val.updated_at);
                          let formattedUp = up.toISOString().replace("T", " ").slice(0, 16);
                          if (abbrev !== "UTC") {
                            const formattedDate = new Date(val.updated_at).toLocaleString("en-US", {
                              timeZone: timezone, year: "numeric", month: "numeric", day: "numeric", hour12: true, hour: "numeric", minute: "2-digit"
                            });
                            const [datePart, timePart] = formattedDate.split(",");
                            const [month, day, year] = datePart.split("/");
                            formattedUp = `${year}-${parseInt(month)}-${parseInt(day)}, ${timePart}`;
                          }
                          return (
                            <Card className="border-0 card-wrapper m-0 mb-3 p-3 shadow-sm rounded-4 m-4 w-auto" key={key}>
                              <div className="row align-items-center g-0">
                                <div className="col-12 p-2">
                                  <div className="d-flex justify-content-between align-items-start">
                                    <span className="fw-bold">
                                      {(page - 1) * displaying_items + key + 1}. {val.mock.title}
                                    </span>
                                    <span className="text-muted small">
                                      {val.local_date ? convertTo12Hrs(val.local_date) : formattedUp + abbrev}
                                    </span>
                                  </div>
                                  <div className="d-flex flex-wrap gap-2 mt-2 align-items-center">
                                    {score ? (
                                      <>
                                        <NavLink to={"/admin/result/" + val.id} className="btn btn-sm btn-outline-primary py-1 px-2" style={{ fontSize: '11px' }}>
                                          Feedback
                                        </NavLink>
                                        <NavLink to={"/admin/scorecard/" + `${location.pathname !== "/admin/results" ? 'Mock' : 'Extensive'}/` + val.id} className="btn btn-sm btn-outline-secondary py-1 px-2" style={{ fontSize: '11px' }}>
                                          Scorecard
                                        </NavLink>
                                        <NavLink to={"/admin/analysis/"+ `${location.pathname !== "/admin/results" ? 'Mock' : 'Extensive'}/` + val.id} className="btn btn-sm btn-outline-info py-1 px-2" style={{ fontSize: '11px' }}>
                                          Analysis
                                        </NavLink>
                                        <NavLink to={"/mock-feedback/" + val.id} className="btn btn-sm btn-outline-success py-1 px-2" style={{ fontSize: '11px' }}>
                                          Tutor
                                        </NavLink>
                                      </>
                                    ) : (
                                      <span className="text-warning small">Please Wait...</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Card>
                          );
                        })}
                      </div>
                    </>
                  )}
                  <MockPagination
                    total={total}
                    listing={displaying_items}
                    updateListingItems={updateListingItems}
                    page={page}
                    paginationChange={paginationChange}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MockResult;

// constructor(props) {
//   super(props);
//   this.state = {
//     data: [],
//     activeTab: 1,
//     currentSection: "Speaking Section",
//     timezone: "",
//     abbrev: "UTC",
//   };
// }

// componentDidMount() {

//   // Add this on priority
//   document.body.classList.add("leftSidebarClosed");

//   let new_format = 0;
//   if (this.props.location.pathname === "/admin/results") {
//     new_format = 1;
//   }

//   this.getMocks(new_format);

//   const timeZones = getTimeZones();

//   const { country_residence, country_state } = store.getState().user;
//   if (country_residence) {
//     const country = Object.values(getAllCountries()).find(
//       (obj) => obj.name === country_residence
//     );
//     if (country) {
//       if (country.timezones.length === 1) {
//         const timezone = country.timezones[0];
//         const abbrev = timeZones.find(
//           (obj) => obj.name === timezone
//         ).abbreviation;
//         // console.log(moment.tz(timezone).format('z'))
//         this.setState({ abbrev: abbrev, timezone: timezone });
//       }
//     }
//   }
// }

// componentDidUpdate(prevProps) {
//   if (this.props.location.pathname !== prevProps.location.pathname) {
//     if (this.props.location.pathname === "/admin/results") {
//       this.getMocks(1);
//     } else if (this.props.location.pathname === "/admin/mock-result") {
//       this.getMocks(0);
//     }
//   }
// }

// getMocks = (new_format) => {
//   API({
//     method: "GET",
//     url: "mock/result?new_format=" + new_format,
//   })
//     .then((data) => {
//       this.props.location.pathname === "/admin/results" &&
//         this.toggle(1);
//       this.setState({ data: data.data.result });
//     })
//     .catch(() => {});
// };
